<template>
    <CustomHeader :text="$t('giftCode.exchangeReward')" />
    <div class="cuponContainer">
        <div class="gift-banner">
            <img :src="dataSet.bannerIcon" alt="banner" class="banner-img" />
            <div class="middleCard">
                <van-row class="middle-row">
                    <van-col span="24">
                        <span class="top-text">{{ $t('giftCode.pasteText') }}:</span>
                        <van-row class="couponInput">
                            <van-col span="17"><van-field class="pasteInput" :placeholder="$t('giftCode.insertPaste')"
                                    v-model="couponCode" /></van-col>
                            <van-col span="6" style="display: flex; justify-content: flex-end; align-items: center;">
                                <button class="copy-btn" @click="pasteCode">
                                    {{ $t('common.colar') }}
                                </button>
                            </van-col>

                        </van-row>
                        <span class="top-text" style="color:#ffa4d170;font-size: 12px;top: 16.5vh;left: 28%;">
                            {{ $t('giftCode.pasteInstructions') }}</span>
                        <div class="exchange-btn">
                            <button v-if="couponCode" class="exchange-btn-active" @click="claimSubmit">
                                {{ $t('common.exchange') }}
                            </button>
                            <button v-else class="exchange-btn-disabled" disabled>
                                {{ $t('common.exchange') }}
                            </button>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="shareIconContainer">
            <van-row class="shareCard">
                <van-col span="4" class="titleImage">
                    <img src="@/assets/gift_code/tracoImg1.png" alt="banner" />
                </van-col>
                <van-col span="20" class="titleText" style="display: flex; align-items: center;">
                    {{ $t('giftCode.mediaTitle') }}
                </van-col>
                <van-col span="24">
                    <div class="mediaIcons">
                        <img src="@/assets/sideNavbar/18+_cai.png" alt="banner" class="media-img" @click="goToShare" />

                        <img src="@/assets/sideNavbar/facebook_cai.png" alt="banner" class="media-img"
                            @click="goToShare" />

                        <img src="@/assets/sideNavbar/Telegram_cai.png" alt="banner" class="media-img"
                            @click="goToShare" />

                    </div>
                </van-col>
            </van-row>
        </div>

        <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
            <div class="title">{{ $t('common.activityTitle') }}</div>

            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
    <!-- 

        
    </div>-->
</template>
<script setup lang="ts">

import { GiftCodeData } from '@/view/giftCode/giftCodeView';
import { watch, ref, defineEmits, defineProps } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';

const emits = defineEmits(['pasteCode', 'goToShare', 'claimSubmit'])

const props = defineProps<{
    dataSet: GiftCodeData
}>()

const couponCode = ref(props.dataSet.couponCode)

watch(
  () => props.dataSet.couponCode,
  val => (couponCode.value = val)
);

const pasteCode = async () => {
  try {
    const text = await navigator.clipboard.readText();
    if (!text) return;

    couponCode.value = text;
    emits('pasteCode', text); 
  } catch (err) {
    console.error('Paste failed', err);
  }
};
const claimSubmit = () => {
    console.log("Cupon code", couponCode.value)
    emits('claimSubmit', couponCode.value)
}
const goToShare = async () => {
    emits("goToShare")
}

</script>
<style scoped>
.cuponContainer {
    padding: 50px 0;
    background-color: #221b24 !important;
}

.gift-banner {
    position: relative;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.banner-img {
    width: 100%;
}

.middleCard {
    background-color: #3f2e4b;
    border-radius: 15px;
    /* border-bottom: 3px solid #dd7a33;
    border-top: 3px solid #dd7a33; */
    padding: 15px 15px 0px;
    position: absolute;
    bottom: 15px;
    width: 80%;
}

.couponInput {
    margin: 10px 0;
    color: #FFF;
    /* border: 1px solid #dd7a33; */
    background-color: #00000040 !important;
    border-radius: 10px;
}

.shareIconContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.shareCard {
    color: #ffa4d1;
    /* border: 1px solid #dd7a33; */
    /* background: #30240f; */
    background: linear-gradient(90deg,
            rgb(67, 46, 79) 0%,
            rgb(200, 84, 173) 50%,
            rgb(67, 46, 79) 100%);

    border-radius: 10px;
    width: 80%;
    padding: 10px;
}

.titleImage img {
    width: 65%;
}

.titleText {
    font-weight: bold;
    font-size: 13px;
    color: #ffa4d1;
}

.mediaIcons {
    background: #0000005c;
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.mediaIcons img {
    width: 30px;
    padding: 5px 10px;
}

.middle-row {
    position: relative;
}

.exchange-btn {
    display: flex;
    justify-content: center;
    padding: 15px;
}

.exchange-btn img {
    width: 40%;
}

.bottom_text {
    padding: 25px;
}

.title {
    color: #7a4289;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #86718c;
    font-size: 13px;
    padding: 5px;
}


.giftCode_container {
    min-height: 100vh;
    padding: 0rem 1rem;
}

::v-deep .exchange-btn .van-button--large {
    color: #FCD7A1;
    font-weight: bold;
    background-image: linear-gradient(#F39A4F 0%, #78340F 100%);
    border: 2px solid #FCD7A1;
    text-align: center;
    font-size: .426rem;
    box-shadow: 0 8px 12px 0 rgba(120, 52, 15, 0.45);
    border-radius: 30px;
}

.middle-card {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.top-text {
    color: #FFFFFFD9;
    font-size: 14px;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
}

.activity-text {
    color: #FFFFFF73;
    font-size: 14px;
    margin: 10px 0px;
    line-height: 20px;
}

.middle-container {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 27vh;
    position: relative;

}


.couponInput ::v-deep .van-field {
    line-height: 1.64rem !important;
    background: transparent !important;
    font-size: 10px !important;
    padding: 5px 10px !important;
}

.couponInput ::v-deep .van-field__control {
    font-size: 15px;
    padding: 5px 0px;
    color: #ffffff !important;
}

.couponInput ::v-deep(.van-field__control::placeholder) {
    color: #86718c !important;
    font-size: 14px !important;
    opacity: 1;
}

::v-deep(.pasteInput .van-field__control::placeholder) {
    color: #ffffff73 !important;
    font-size: 15px;
    opacity: 1;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 25vh 0vh 0vh;
}

.media-img-content {
    width: 8%;
    background-color: #ffffff0a;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    left: 47%;
    top: 322%;
    border: 5px solid #ffffff0a;
}

.media-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #FFFFFFD9;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}


.copy-btn {
    width: 100%;
}

.exchange-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

/* Active (enabled) button */
.exchange-btn-active {
    background-color: #ff3d9e;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 18px;
    font-size: 14px;
    font-weight: 600;
    width: 120px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.exchange-btn-active:hover {
    background-color: #e7338b;
}

.exchange-btn-active:active {
    background-color: #cc2a7a;
}

/* Disabled button */
.exchange-btn-disabled {
    background-color: #e66fc8;
    color: #ffffffb3;
    border: none;
    border-radius: 8px;
    width: 120px;
    padding: 8px 18px;
    font-size: 14px;
    font-weight: 600;
    cursor: not-allowed;
    opacity: 0.7;
}

.copy-btn {
    background-color: #ff3d9e;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 600;
    width: 70px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.copy-btn:hover {
    background-color: #e7338b;
}

.copy-btn:active {
    background-color: #cc2a7a;
}
</style>